import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoLocksGetRes } from "./abst/DtoLocksGetRes";

export class DtoLocksGetResImple extends DtoLocksGetRes {
  public processingDate = "";

  public pager = new DtoApiPager();
}
